
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { toODataString } from '@progress/kendo-data-query';
import { Observable ,  BehaviorSubject } from 'rxjs';


import { RIAHelper } from './ria-helper'
import { environment} from '../../environments/environment'
import { MsgResult } from 'app/core';
import { CreateFromStandardAudit } from './models/CreateFromStandardAudit-model';
import { CreateReverseAudit } from './models/CreateReverseAudit';



@Injectable()
 export class RvrsService  {

 private domainStr: string;
  private RIABASE_URL: string;

  constructor(private http: Http) {
    this.domainStr = environment.baseWebApiUrl;
    this.RIABASE_URL = environment.baseWebApiUrl + 'api/RIA/';
   }

  private filterToString({ filter }: { filter?: string }): string {
    return filter ? `&$filter=${filter}` : '';
  }

  public dynamicSort<T>(property: string, dir: string): (a: T, b: T) => number {
    let sortOrder = (dir === "desc") ? -1 : 1;
    return (a, b) => {
      let result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
      return result * sortOrder;
    }
  }

   getReverseAuditGridData(state):Observable<GridDataResult>{
     return this.http.get(this.domainStr + "api/ReverseAudit/Get").pipe(
      map(response => response.json()),
      map((response) => {
        let sorted = response;
        if (state.sort && state.sort.length > 0) {
          let srt = state.sort[0];
          let srtFn = this.dynamicSort(srt.field, srt.dir);
          sorted = sorted.sort(srtFn);
        }
        let subsetSorted = sorted.slice(state.skip, state.skip + state.take);

        return (<GridDataResult>{
          data: subsetSorted,
          total: sorted.length
        });
      }),);
   }

   getStandardAuditData(auditId){
    return this.http.get(this.domainStr + "api/ReverseAudit/BeginReverseAudit?AuditID="+auditId).pipe(
    map(response => response.json()),
    map((response) => {
      let sorted = response;
      sorted.Properties.forEach(element => {
        element.PropertyNameLowerCase = element.PropertyName.toLowerCase();
        element.PropertyAddressLowerCase = element.PropertyAddress.toLowerCase();
        element.PropertyCityLowerCase = element.PropertyCity.toLowerCase();
        element.PropertyCountryLowerCase = element.PropertyCountry.toLowerCase();
      });
      return ({
        data: sorted,
        length:response.length
      });
    }),);
   }
  GetRvrsAuditChart(auditID: any) {
    let service = 'AuditRvrReportGraphRunStats?auditId=' + auditID;
    return this.http.get(this.RIABASE_URL + service).pipe(
      map(response => response.json()),);
  }
  save(data:CreateReverseAudit):Observable<MsgResult>{
    return this.http.post(this.domainStr + "api/ReverseAudit" , data).pipe(
      map(response => response.json()));
  }


  public CreateRateAuditInReverseAudit(objAuditAvl: CreateFromStandardAudit) {
    return this.http.post(this.domainStr + "api/ImportAudit/Post" , objAuditAvl).pipe(
    map(response => response.json()));
  }
 }
